export const CATEGORY_CODE_NEED_CALL_SHOP = ['ACRYLIC'];
